import {
  Flex,
  Link,
  Text as ChakraText,
  Tooltip,
  VStack,
} from '@chakra-ui/react'
import React, { useContext } from 'react'
import { NavLink } from 'react-router-dom'
import { colors } from '../../../ui-kit'
import { encodeHash } from '../../../utils'
import { addLeadingSlash } from '../../../utils/urlHelpers'
import type { UrlEndpointsResponse } from '../../interfaces'
import { UserContext } from '../../providers'

interface Props {
  urlEndpoint: UrlEndpointsResponse
  path: string
}

const UrlEndpointItem = ({
  urlEndpoint,
  path,
}: Props): React.ReactElement | null => {
  const { user } = useContext(UserContext)
  if (!user) {
    return null
  }

  return (
    <Link
      key={urlEndpoint.id}
      as={NavLink}
      width="full"
      to={`${path}/${encodeHash(urlEndpoint.id)}`}
      _hover={{ textDecoration: 'none', outline: 'none' }}
      _focus={{ textDecoration: 'none', outline: 'none' }}
      _active={{ textDecoration: 'none', outline: 'none' }}
      outline="none"
      activeStyle={{
        background: colors.appPaleGreyThree,
        borderColor: '#e1e4eb',
      }}
      border="1px solid transparent"
      borderRadius="4px"
    >
      <VStack spacing="0.5em" align="left" padding="0.5em" width="full">
        <Tooltip
          label={
            urlEndpoint.isDefault
              ? user.baseUrlForClientImageFetch
              : addLeadingSlash(urlEndpoint.urlPrefix)
          }
        >
          <ChakraText
            width="full"
            fontSize="md"
            fontWeight="medium"
            color={colors.appDarkIndigo}
            lineHeight="base"
            isTruncated
          >
            {urlEndpoint.isDefault
              ? user.baseUrlForClientImageFetch
              : addLeadingSlash(urlEndpoint.urlPrefix)}
          </ChakraText>
        </Tooltip>
        <Tooltip label={urlEndpoint.desc}>
          <ChakraText
            width="full"
            fontSize="sm"
            lineHeight="base"
            color={colors.appBattleshipGrey}
            isTruncated
          >
            {urlEndpoint.desc}
          </ChakraText>
        </Tooltip>
        {urlEndpoint.cnameArr?.length && urlEndpoint.cnameArr.length > 0 && (
          <Flex>
            <ChakraText
              marginRight={2}
              fontSize="sm"
              color={colors.appBattleshipGrey}
              lineHeight="base"
            >
              {urlEndpoint.cnameArr
                .map(cname => new URL(cname).hostname)
                .join(', ')}
            </ChakraText>
          </Flex>
        )}
      </VStack>
    </Link>
  )
}

export default UrlEndpointItem
